import { Injectable } from '@angular/core';
import { InAppBrowser, OpenWebViewOptions, type UrlEvent } from '@capgo/inappbrowser';
import { Capacitor, type PluginListenerHandle } from '@capacitor/core';

const DEFAULT_TOOLBAR_COLOR = '#0e53a1';
const DEFAULT_TOOLBAR_TEXT_COLOR = '#ffffff';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  async openInApp(url: string, options: Partial<OpenWebViewOptions> = {}): Promise<void> {
    const parsed = new URL(url);
    if (!['http:', 'https:'].includes(parsed.protocol)) {
      throw new Error('Invalid URL protocol');
    }

    if (!Capacitor.isNativePlatform()) {
      window.open(url, '_system');
      return;
    }

    await InAppBrowser.openWebView({
      url,
      title: 'Movilidad Tec',
      toolbarColor: DEFAULT_TOOLBAR_COLOR,
      toolbarTextColor: DEFAULT_TOOLBAR_TEXT_COLOR,
      showArrow: true,
      ...options,
    });
  }

  openExternal(url: string): void {
    window.open(url, '_system');
  }

  async addUrlChangeListener(callback: (event: UrlEvent) => void): Promise<PluginListenerHandle> {
    return InAppBrowser.addListener('urlChangeEvent', callback);
  }

  /** Avisa cuando el usuario cierra el navegador embebido por su cuenta. */
  async addCloseListener(callback: () => void): Promise<PluginListenerHandle> {
    return InAppBrowser.addListener('closeEvent', callback);
  }

  async close(): Promise<void> {
    await InAppBrowser.close();
  }
}
